import React from "react";
import Select from 'react-select';
import { useEffect, useContext, useState } from "react";
import { AuthContext } from "../Routes/AuthProvider";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { GetCorporateDetails, GetCorporateDetailsAvailableBalance } from "../Services/API"
import { GetTravellersByCorporateCode } from "../Services/API"

const HeaderDashboard = () => {
	const { logout, name, userName, roles } = useContext(AuthContext);
	const navigate = useNavigate();

	const [legalEntities, setLegalEntities] = useState([]);
	const [travellers, setTravellers] = useState([]);
	const [loadingEntities, setLoadingEntities] = useState(false);
	const [errors, setErrors] = useState({});
	const [emulateMsg, setEmulateMsg] = useState("");
	const [isEmulated, setIsEmulated] = useState(false);

	const [emulateCorporateCode, setEmulateCorporateCode] = useState("");
	const [emulateUser, setEmulateUser] = useState("");
	const [emulateCorporateName, setEmulateCorporateName] = useState("");
	const [emulateCorporateCreditLimit, setEmulateCorporateCreditLimit] = useState(0);
	const [availableBalance, setAvailableBalance] = useState("Loading ...");
	const [loadingTravellers, setLoadingTravellers] = useState(false);
	const [selectedCorporate, setSelectedCorporate] = useState("");
	const [selectedUser, setSelectedUser] = useState("");
	//const [loadingTravellers, setLoadingTravellers] = useState(false);
	const [selectedCorporateName, setSelectedCorporateName] = useState("");


	useEffect(() => {
		const corporate = localStorage.getItem("selectedCorporateCode");
		const userId = localStorage.getItem("selectedUserId");
		const CorporateName = localStorage.getItem("selectedCorporateName");

		if (corporate) setSelectedCorporate(corporate);
		if (userId) setSelectedUser(userId);
		if (CorporateName) setSelectedCorporateName(CorporateName);
	}, []);

	const fetchCorporateDetails = async () => {
		try {
			setLoadingEntities(true);
			const res = await GetCorporateDetails(userName);
			setLegalEntities(res || []);
		} catch (error) {
			console.error("Error fetching corporate details", error);
		} finally {
			setLoadingEntities(false);
		}
	};

	const handleCorporateChange = async (e) => {
		const corporateCode = e;
		setEmulateCorporateCode(corporateCode);
		setEmulateUser("");
		setTravellers([]);
		setErrors({});

		const corpObj = legalEntities.find(
			(c) => c.corporateCode === corporateCode
		);

		setEmulateCorporateName(corpObj?.corporateName || "");
		setEmulateCorporateCreditLimit((corpObj?.availableBalance ?? 0) || ((corpObj?.creditLimit ?? 0) + (corpObj?.dueAmount ?? 0)));

		if (!corporateCode) return;

		try {
			setLoadingTravellers(true);
			const data = await GetTravellersByCorporateCode(corporateCode);
			setTravellers(data || []);
		} catch (err) {
			console.error(err);
		} finally {
			setLoadingTravellers(false);
		}
	};

	const handleUserIdChange = async (value) => {
		setEmulateUser(value);
	};

	const handleEmulateRequest = () => {
		if (!emulateCorporateCode) {
			setErrors({ corporate: "Please select a corporate" });
			return;
		}

		localStorage.setItem("selectedCorporateCode", emulateCorporateCode);
		localStorage.setItem("selectedCorporateName", emulateCorporateName);
		localStorage.setItem("selectedUserId", emulateUser);

		setSelectedCorporate(emulateCorporateCode);
		setSelectedUser(emulateUser);
		setSelectedCorporateName(emulateCorporateName);
		setIsEmulated(true);

		setEmulateMsg(
			`Emulation set for ${emulateCorporateName} (${emulateCorporateCode}), Balance : ₹ ${emulateCorporateCreditLimit}`
		);
	};

	const handleClearEmulate = () => {
		localStorage.removeItem("selectedCorporateCode");
		localStorage.removeItem("selectedCorporateName");
		localStorage.removeItem("selectedUserId");

		setSelectedCorporate("");
		setSelectedCorporateName("");
		setSelectedUser("");
		setEmulateMsg("");
		setIsEmulated(false);

	};


	useEffect(() => {
		if (window.KTMenu) {
			window.KTMenu.init();
		}
		if (window.KTDrawer) {
			window.KTDrawer.init();
		}
		if (window.KTScroll) {
			window.KTScroll.init();
		}
	}, []);



	const handleLogout = () => {
		setSelectedCorporate("");
		setSelectedUser("");
		localStorage.removeItem("selectedCorporateCode");
		localStorage.removeItem("selectedCorporateName");
		localStorage.removeItem("selectedUserId");
		setEmulateMsg("");
		logout();
		navigate("/login", { replace: true });
	};

	const corporateOptions = legalEntities.map(item => ({
		value: item.corporateCode,
		label: `${item.corporateName} (${item.corporateCode})`
	}));

	const travellersOptions = travellers.map(item => ({
		value: item.userName,
		label: `${item.firstName} ${item.lastName} (${item.userName})`
	}));

	const CloseEmulateRequest = () => {
		window.location.reload();
	}

	const handleProfileClick = async () => {
		const corporateCode = localStorage.getItem("selectedCorporateCode");
		if (corporateCode) {
			const res = await GetCorporateDetailsAvailableBalance(corporateCode);
			setAvailableBalance(res.availableBalance)
		}
	};
	return (
		<>
			<div class="d-flex flex-column flex-root">
				<div class="page d-flex flex-row flex-column-fluid">
					<div id="kt_aside" class="aside overflow-visible pb-5 pt-5 pt-lg-0" data-kt-drawer="true" data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'80px', '300px': '100px'}" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle">

						<div class="aside-menu flex-column-fluid" id="kt_aside_menu">
							<div class="hover-scroll-y my-2 my-lg-5 scroll-ms" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
								<div class="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold" id="#kt_aside_menu" data-kt-menu="true">

									{["Corporate Traveller"].some(role => roles?.includes(role)) && (
										<>
											<div class="menu-item py-2">
												<a href="/Dashboard" className="hrd_dash">
													<i class="ki-outline ki-graph-up fs-2x"></i>
													<span class="menu-title">Dashboard</span>
												</a>
											</div>
											<div class="menu-item py-2">
												<a href="/dashboard/mybooking" className="hrd_dash">
													<i class="ki-outline ki-book fs-2x"></i>
													<span class="menu-title">My Booking</span>
												</a>
											</div>
											<div class="menu-item py-2">
												<a href="/settings" className="hrd_dash">
													<i class="ki-outline ki-gear fs-2x"></i>
													<span class="menu-title">Settings</span>
												</a>
											</div>
											<div class="menu-item py-2">
												<a href="/dashboard/TripQueue" className="hrd_dash">
													<i class="ki-outline ki-gear fs-2x"></i>
													<span class="menu-title">Trip Queue</span>
												</a>
											</div>
										</>
									)}
									{["TMC Operations", "TMC Manager", "Corp Administrator", "Corp Travel Manager"].some(role => roles?.includes(role)) && (
										<>
											<div class="menu-item py-2">
												<a href="/Dashboard" className="hrd_dash">
													<i class="ki-outline ki-graph-up fs-2x"></i>
													<span class="menu-title">Dashboard</span>
												</a>
											</div>
											<div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item py-2">
												<div class="menu-link text-center">
													<i class="ki-outline ki-notification-status fs-2x"></i>
													<span class="menu-tit">Reports</span>
												</div>
												<div class="menu-sub menu-sub-dropdown menu-sub-indention px-2 py-4 w-250px mh-75 overflow-auto">
													<div class="menu-item">
														<div class="menu-content">
															<h6>Reports</h6>
														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-plane fs-2"></i>
															</span>
															<span class="menu-title">Flight</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Flight/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Flight/lowfareflightreport">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">Low Fare Flight</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-hotel fs-2"></i>
															</span>
															<span class="menu-title">Hotel</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Hotel/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>

															<div class="menu-item">
																<a class="menu-link" href="/Reports/Hotel/CancelledBookings">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">Cancelled Bookings</span>
																</a>
															</div>
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Hotel/lowfarehotels">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">Lowfare Hotels</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-bus fs-2"></i>
															</span>
															<span class="menu-title">Bus</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Bus/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-car fs-2"></i>
															</span>
															<span class="menu-title">Cabs</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Cab/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-passport fs-2"></i>
															</span>
															<span class="menu-title">Visa</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Visa/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-inr fs-2"></i>
															</span>
															<span class="menu-title">Forex</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Forex/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-umbrella fs-2"></i>
															</span>
															<span class="menu-title">Insurance</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Insurance/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-train fs-2"></i>
															</span>
															<span class="menu-title">Rail</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reports/Train/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="right-start" class="menu-item py-2">
												<div class="menu-link text-center">
													<i class="ki-outline ki-notification-status fs-2x"></i>
													<span class="menu-tit">Reservations</span>
												</div>
												<div class="menu-sub menu-sub-dropdown menu-sub-indention px-2 py-4 w-250px mh-75 overflow-auto">
													<div class="menu-item">
														<div class="menu-content">
															<h6>Reservations</h6>
														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-plane fs-2"></i>
															</span>
															<span class="menu-title">Flight</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Flight/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-hotel fs-2"></i>
															</span>
															<span class="menu-title">Hotel</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Hotel/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-bus fs-2"></i>
															</span>
															<span class="menu-title">Bus</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Bus/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-car fs-2"></i>
															</span>
															<span class="menu-title">Cabs</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Cab/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-passport fs-2"></i>
															</span>
															<span class="menu-title">Visa</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Visa/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>
														</div>
													</div>
													{/* start */}
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-inr fs-2"></i>
															</span>
															<span class="menu-title">Forex</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Forex/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>

														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-umbrella fs-2"></i>
															</span>
															<span class="menu-title">Insurance</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Insurance/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>

														</div>
													</div>
													<div data-kt-menu-trigger="click" class="menu-item menu-accordion">
														<span class="menu-link">
															<span class="menu-icon">
																<i class="fa fa-train fs-2"></i>
															</span>
															<span class="menu-title">Rail</span>
															<span class="menu-arrow"></span>
														</span>
														<div class="menu-sub menu-sub-accordion">
															<div class="menu-item">
																<a class="menu-link" href="/Reservations/Train/AllTransactions">
																	<span class="menu-bullet">
																		<span class="bullet bullet-dot"></span>
																	</span>
																	<span class="menu-title">All Transactions</span>
																</a>
															</div>

														</div>
													</div>
													{/* start */}
												</div>
											</div>
											<div class="menu-item py-2">
												<a href="/settings" className="hrd_dash">
													<i class="ki-outline ki-gear fs-2x"></i>
													<span class="menu-title">Settings</span>
												</a>
											</div>
										</>
									)}






								</div>
							</div>
						</div>
					</div>
					<div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
						<div id="kt_header" class="header align-items-stretch">
							<div class="container-fluid d-flex align-items-stretch justify-content-between">
								<div class="d-flex align-items-center d-lg-none ms-n1 me-2" title="Show aside menu">
									<div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
										<i class="ki-outline ki-abstract-14 fs-1"></i>
									</div>
								</div>
								<div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
									<a href="/" class="d-lg-none">
										<img alt="Logo" src="/assets/images/logo.png" class="h-35px" />
									</a>
								</div>
								<div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
									<div class="d-flex align-items-stretch" id="kt_header_nav">
										<div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
											<div class="menu menu-rounded menu-column menu-lg-row menu-active-bg menu-state-primary menu-title-gray-700 menu-arrow-gray-500 fw-semibold my-5 my-lg-0 px-2 px-lg-0 align-items-stretch" id="#kt_header_menu" data-kt-menu="true">
												<div className="logo_company"><img alt="Logo" className='logo_ch' src='/assets/images/logo.png' /></div>
												<div className='Navig_company'>
													<ul className="nav nav_bar navigation">
														<li>
															<a
																href="/flight"
																className={`nav_link ${window.location.pathname === "/flight" ? "active" : ""}`}
															>
																<img src="/assets/images/flight-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/flight.png" className="icon_icon_hide" alt="" />
																<p>Flight</p>
															</a>
														</li>

														<li>
															<a
																href="/hotel"
																className={`nav_link ${window.location.pathname === "/hotel" ? "active" : ""}`}
															>
																<img src="/assets/images/Hotel-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Hotel.png" className="icon_icon_hide" alt="" />
																<p>Hotel</p>
															</a>
														</li>

														<li>
															<a
																href="/bus"
																className={`nav_link ${window.location.pathname === "/bus" ? "active" : ""}`}
															>
																<img src="/assets/images/Bus-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Bus.png" className="icon_icon_hide" alt="" />
																<p>Bus</p>
															</a>
														</li>

														<li>
															<a
																href="/cabs"
																className={`nav_link ${window.location.pathname === "/cabs" ? "active" : ""}`}
															>
																<img src="/assets/images/Cab-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Cab.png" className="icon_icon_hide" alt="" />
																<p>Cabs</p>
															</a>
														</li>

														<li>
															<a
																href="/visa"
																className={`nav_link ${window.location.pathname === "/visa" ? "active" : ""}`}
															>
																<img src="/assets/images/Visa-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Visa.png" className="icon_icon_hide" alt="" />
																<p>Visa</p>
															</a>
														</li>

														<li>
															<a
																href="/forex"
																className={`nav_link ${window.location.pathname === "/forex" ? "active" : ""}`}
															>
																<img src="/assets/images/Forex-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Forex.png" className="icon_icon_hide" alt="" />
																<p>Forex</p>
															</a>
														</li>

														<li>
															<a
																href="/insurance"
																className={`nav_link ${window.location.pathname === "/insurance" ? "active" : ""}`}
															>
																<img src="/assets/images/Insurance-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/Insurance.png" className="icon_icon_hide" alt="" />
																<p>Insurance</p>
															</a>
														</li>

														<li>
															<a
																href="/rail"
																className={`nav_link ${window.location.pathname === "/rail" ? "active" : ""}`}
															>
																<img src="/assets/images/train-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/train.png" className="icon_icon_hide" alt="" />
																<p>Rail</p>
															</a>
														</li>

														<li>
															<a
																href="/approval"
																className={`nav_link ${window.location.pathname === "/approval" ? "active" : ""}`}
															>
																<img src="/assets/images/approval-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/approval.png" className="icon_icon_hide" alt="" />
																<p>Approval</p>
															</a>
														</li>

														<li>
															<a
																href="/dashboard"
																className={`nav_link ${window.location.pathname === "/dashboard" ? "active" : ""}`}
															>
																<img src="/assets/images/dashboard-white.png" className="icon_icon" alt="" />
																<img src="/assets/images/dashboard.png" className="icon_icon_hide" alt="" />
																<p>Dashboard</p>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
									<div class="d-flex align-items-stretch flex-shrink-0">
										<div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">

											<div class="cursor-pointer symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" onClick={handleProfileClick}>
												<img src="/assets/images/profile.png" alt="pics" />
											</div>

											<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" data-kt-menu="true">
												<div class="menu-item px-3">
													<div class="menu-content d-flex align-items-center px-3">
														<div class="symbol symbol-50px me-5">
															<img alt="Logo" src="/assets/images/profile.png" />
														</div>
														<div class="d-flex flex-column">
															<div class="fw-bold align-items-center fs-5 ellipses">{name || "User"}
															</div>
															{["TMC Operations", "TMC Manager", "Corp Travel Manager"].some(role => roles?.includes(role)) && (
																<a href="#" data-bs-toggle="modal" data-bs-target="#Emulate" className="menu-text-success mt-2" onClick={fetchCorporateDetails} >
																	Emulate
																</a>
															)}
														</div>
													</div>
												</div>
												<div class="separator my-2"></div>
												<div class="menu-item px-5">
													{selectedCorporate && (
														<>
															<div>
																<p className="copr_usr">
																	{selectedCorporateName} ({selectedCorporate})
																</p>
																<p className="copr_usr_n">
																	{selectedUser}
																</p>
																<p className="copr_usr_n">
																	Balance : ₹ {availableBalance}
																</p>
																<button
																	className="btn btn-primary btn-sm mt-3"
																	onClick={handleClearEmulate}
																>
																	Clear
																</button>
															</div>




															<div className="separator my-2"></div>
														</>
													)}

												</div>
												<div class="menu-item px-5">
													<a href="/settings/Myprofile" class="menu-link px-5">My Profile</a>
												</div>
												<div class="menu-item px-5">
													<button class="menu-link px-5" onClick={handleLogout}>Logout</button>
												</div>
											</div>
										</div>
										<div class="d-flex align-items-center d-lg-none ms-2 me-n2" title="Show header menu">
											<div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_header_menu_mobile_toggle">
												<i class="ki-outline ki-burger-menu-2 fs-1"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal fade" id="Emulate">
						<div class="modal-dialog modal-lg">
							<div class="modal-content">
								<div class="modal-header">
									<h4 class="modal-title">Emulate Roles</h4>
									<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
								</div>

								<div class="modal-body">
									{emulateMsg && (
										<div className="alert alert-info">
											{emulateMsg}
										</div>
									)}
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label className="required">Legal Entity</label>
												<Select
													className="react-select-container"
													classNamePrefix="react-select"
													placeholder="--Select--"
													isLoading={loadingEntities}
													options={corporateOptions}
													value={
														corporateOptions.find(
															option => option.value === emulateCorporateCode
														) || null
													}
													onChange={(selectedOption) => {
														handleCorporateChange(selectedOption?.value || "");
													}}
												/>
												{errors.corporate && <p className="text-danger">{errors.corporate}</p>}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Corporate Traveller</label>
												<Select
													className="react-select-container"
													classNamePrefix="react-select"
													placeholder="--Select--"
													isLoading={loadingTravellers}
													options={travellersOptions}
													value={
														travellersOptions.find(
															option => option.value === emulateUser
														) || null
													}
													onChange={(selectedOption) => {
														handleUserIdChange(selectedOption?.value || "");
													}}
												/>
											</div>
										</div>
										<div className="col-md-12 text-end">
											{/* <button className="btn btn-warning mx-2" data-bs-dismiss="modal">Close</button> */}
											<button className="btn btn-warning mx-2" data-bs-dismiss="modal" onClick={CloseEmulateRequest}>Close</button>
											{!isEmulated && (
												<button className="btn btn-primary" onClick={handleEmulateRequest}>Confirm</button>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default HeaderDashboard;
